import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { changelogPath, changelogProducts } from "@/lib/changelog";
import type { ChangelogTag } from "@/lib/changelog";
export function ChangelogTags(t0) {
  const $ = _c(4);
  const {
    tags
  } = t0;
  let t1;
  if ($[0] !== tags) {
    t1 = tags.map(_temp);
    $[0] = tags;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <ul aria-label="Products" className="not-prose flex flex-wrap gap-2">{t1}</ul>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(tag) {
  return <li key={tag}><Link href={changelogPath(tag)} className="inline-flex min-h-8 items-center rounded-full border border-border px-3 py-1 text-xs font-medium text-muted-foreground transition-colors hover:bg-muted hover:text-foreground focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring">{changelogProducts[tag].name}</Link></li>;
}